module.exports = __webpack_public_path__ + "static/media/chats.8b191c2d.svg";